
import '../App.css';
import Header from '../components/Header';
import AboutMore from "../components/AboutMore";
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <AboutMore/>
    
    <Footer/>
    </div>
  );
}

export default App;
